var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ContentDelivery } from '@episerver/spa-core';
export default class SettingsApi {
    constructor(contentDeliveryApi, contentRepositoryApi, serverContext) {
        this.serviceEndpoint = 'api/sampo/v1/settings';
        this._api = contentDeliveryApi;
        this._repo = contentRepositoryApi;
        this._ctx = serverContext;
    }
    /**
     * Get a settings container, either during server side rendering or from the initial context delivered by the
     * server side rendering.
     *
     * @param       container
     * @returns     The settings container, or undefined if not found
     */
    getContainerOnServer(container) {
        const ssrPropName = container.toLowerCase();
        let settingsContainer = this._ctx.getProp(ssrPropName);
        if (!settingsContainer && this._ctx.IsServerSideRendering) {
            const ISettingsService = this._ctx.getEpiserverService('SampoInternet.Infrastructure.Cms.Settings.ISettingsService');
            if (container === 'Navigation')
                settingsContainer = ISettingsService.GetSiteNavigation();
            else if (container === 'CurrentNavigation')
                settingsContainer = ISettingsService.GetCurrentSiteNavigation(this._ctx.getProp('path'));
            else if (container === 'Categories')
                settingsContainer = ISettingsService.GetCategories();
            else
                settingsContainer = ISettingsService.GetSiteSettings(container);
            this._ctx.setProp(ssrPropName, settingsContainer);
            settingsContainer = this._ctx.makeSafe(settingsContainer);
        }
        return settingsContainer;
    }
    listContainers(site) {
        return __awaiter(this, void 0, void 0, function* () {
            site = site || (yield this._repo.getCurrentWebsite());
            // @ToDo: Implement local storage caching...
            let url = this.serviceEndpoint + '/' + site.id;
            return this._api.raw(url).then(r => ContentDelivery.isNetworkError(r[0]) ? [] : r[0]);
        });
    }
    getContainer(container, site) {
        return __awaiter(this, void 0, void 0, function* () {
            site = site || (yield this._repo.getCurrentWebsite());
            const containerKey = `settings.${this._api.Language}.${site.id}.${container}`;
            let cached = null;
            let cacheTimeDiff = 10000;
            let cachedItem = null;
            try {
                cached = localStorage.getItem(containerKey);
                cachedItem = JSON.parse(cached);
                try {
                    cacheTimeDiff = (Math.abs(new Date().getTime() - new Date(cachedItem.timestamp).getTime())) / (1 * 60 * 1000);
                }
                catch (e) {
                }
            }
            catch (e) {
                //Ignore on purpose
            }
            /*
            Local storage cache for settings:
            - Cached response is used if it's less than 12h old.
            - If cached response is over 5 mins old it's updated to cache after use so that next request will have fresher response from cache
            - In other cases new query.
            */
            if ((cachedItem === null || cachedItem === void 0 ? void 0 : cachedItem.data) && cacheTimeDiff && cacheTimeDiff < 720) {
                if (cacheTimeDiff && cacheTimeDiff > 5 && this._api.OnLine) {
                    if (container === 'Categories' || container === 'Navigation')
                        this.getRemoteContainer(container, site).then(x => {
                            const cacheItem = { data: x, timestamp: new Date() };
                            localStorage.setItem(containerKey, JSON.stringify(cacheItem));
                            this._ctx.setProp(container.toLowerCase(), x);
                        }).catch(x => null);
                    else
                        this.getRemoteContainer(container, site).then(x => {
                            const cacheItem = { data: x.data.settings, timestamp: new Date() };
                            localStorage.setItem(containerKey, JSON.stringify(cacheItem));
                            this._ctx.setProp(container.toLowerCase(), x.data.settings);
                        }).catch(x => null);
                }
                try {
                    return typeof (cachedItem.data) === 'string' ? JSON.parse(cachedItem.data) : cachedItem.data;
                }
                catch (e) {
                    //Ignore on purpose
                }
            }
            const result = yield this.getRemoteContainer(container, site);
            try {
                this._ctx.setProp(container.toLowerCase(), container === 'Categories' || container === 'Navigation' ? result : result.data.settings);
                const cacheItem = { data: JSON.stringify(container === 'Categories' || container === 'Navigation' ? result : result.data.settings), timestamp: new Date() };
                localStorage.setItem(containerKey, JSON.stringify(cacheItem));
            }
            catch (e) {
                //Ignore on purpose
            }
            return container === 'Categories' || container === 'Navigation' ? result : result.data.settings;
        });
    }
    getSharePrice() {
        return __awaiter(this, void 0, void 0, function* () {
            const site = yield this._repo.getCurrentWebsite();
            const endpoint = 'api/episerver/v3.0/content/shareprice';
            const containerKey = `shareprice.${this._api.Language}.${site.id}`;
            const result = yield this._api.raw(endpoint).then(r => r[1].status === 200 ? r[0] : null).catch(() => null);
            try {
                localStorage.setItem(containerKey, JSON.stringify(result));
            }
            catch (e) {
                //Ignore on purpose
            }
            return result;
        });
    }
    getRemoteContainer(container, site) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = '';
            if (container !== 'Navigation' && container !== 'Categories') {
                url = this.serviceEndpoint + '/' + site.id + '/' + container;
            }
            else {
                url = this.serviceEndpoint + '/' + container.toLowerCase() + '/' + site.id + '/';
            }
            return this._api.raw(url).then(r => r[1].status === 200 ? r[0] : null).catch(() => null);
        });
    }
}
